"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Copy32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M11.018 8.5v1H10a1.5 1.5 0 00-1.493 1.356L8.5 11v13a1.5 1.5 0 001.356 1.493L10 25.5h9a1.5 1.5 0 001.493-1.356L20.5 24v-1.95h1V24a2.5 2.5 0 01-2.336 2.495L19 26.5h-9a2.5 2.5 0 01-2.495-2.336L7.5 24V11a2.5 2.5 0 012.336-2.495L10 8.5h1.018zm6.963-4a.49.49 0 01.373.146l6 6c.1.1.146.224.147.345L24.5 11v8.118c0 1.313-1.048 2.382-2.346 2.382h-8.308c-1.298 0-2.346-1.069-2.346-2.382V6.882c0-1.313 1.048-2.382 2.346-2.382zm-.481 1h-3.654c-.741 0-1.346.617-1.346 1.382v12.236c0 .765.605 1.382 1.346 1.382h8.308c.741 0 1.346-.617 1.346-1.382V11.5h-3.476a2.52 2.52 0 01-2.519-2.349l-.005-.165V5.5zm1 .707v2.779c0 .789.608 1.438 1.385 1.508l.139.006h2.769L18.5 6.207z", className: "copy-32_svg__path-1" }))); };
var StyledCopy32 = styled_components_1.default(Copy32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledCopy32;
var templateObject_1;
//# sourceMappingURL=Copy32.js.map